import { getResourceFieldCapacityOverrides } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export function useGetFieldCapacityOverrides({
  resourceId,
  enabled = true,
}: {
  resourceId: string;
  // Callers gate this on the per-day field capacity feature flag (ADO #94651)
  // so a flag-off tenant never issues an override request.
  enabled?: boolean;
}) {
  return useQuery(
    ['get-resource-field-capacity-overrides', resourceId],
    () => getResourceFieldCapacityOverrides(resourceId),
    { enabled: enabled && !!resourceId }
  );
}
